/**
 * This client was automatically generated by Segment Typewriter. ** Do Not Edit **
 */

import * as Segment from './segment'

export interface AccountCreated {
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The location of the button or link on the page or screen.
	 */
	button_or_link_location?: string
	/**
	 * The text on the button or link.
	 */
	button_or_link_text?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface AgreedToTosPrivacy {
	/**
	 * The location of the checkbox on the page or screen.
	 */
	checkbox_location?: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface BackButtonPressed {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface ButtonPressed {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface CaptureStarted {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * The name of the page or screen where the button was pressed.

	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface CaptureSubmitted {
	/**
	 * The location of the button on the page or screen.

	 */
	button_location?: string
	/**
	 * The text on the button.

	 */
	button_text: string
	/**
	 * The name of the page or screen where the button was pressed.

	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
	/**
	 * Progressive Uploads was enabled for the capture.
	 */
	progressive_upload?: boolean
}
export interface FeatureUpvoted {
	/**
	 * The name of the feature the user upvoted.
	 */
	feature: string
	/**
	 * The name of the page or screen where the feature was upvoted.
	 */
	page_or_screen_name: string
}
export interface HomeownerIdentified {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface LinkPressed {
	/**
	 * The location of the link on the page or screen.
	 */
	link_location?: string
	/**
	 * The text on the link.
	 */
	link_text: string
	/**
	 * The name of the page or screen where the link was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the link is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface LoginSsoStarted {
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The location of the button or link on the page or screen.
	 */
	button_or_link_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface LoginStarted {
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The location of the button on the page or screen.
	 */
	button_or_link_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface ProductSelected {
	/**
	 * The name of the page or screen where the product was selected.
	 */
	page_or_screen_name: string
	/**
	 * The parameter of the product the user selected. For example, “Roofing Types”, “Style”, etc..
	 */
	parameter: string
	/**
	 * The kind of product the user selected. For example, "Walls", "Roof", "Trim", etc..
	 */
	product: string | null
	/**
	 * The option the user selected. For example, “Metal”, “Standing Seam”, etc..
	 */
	selection: any | null
}
export interface ProfessionalIdentified {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface PropertyPressed {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * Whether the property is an example job.
	 */
	example_job?: boolean
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface SignupStarted {
	/**
	 * The location of the button on the page or screen.
	 */
	button_location?: string
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The text on the button.
	 */
	button_text: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}
export interface SupportContacted {
	/**
	 * Whether the element pressed was a button or a link.
	 */
	button_or_link: string
	/**
	 * The location of the button or link on the page or screen.
	 */
	button_or_link_location?: string
	/**
	 * The text on the button or link.
	 */
	button_or_link_text: string
	/**
	 * The name of the page or screen where the button was pressed.
	 */
	page_or_screen_name: string
	/**
	 * Whether the button is the primary call to action on the page or screen.
	 */
	primary_cta: boolean
}

export type ViolationHandler = (
	message: Record<string, any>,
	violations: any[]
) => void

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler: ViolationHandler = (
	message,
	violations
) => {
	const msg = JSON.stringify(
		{
			type: 'Typewriter JSON Schema Validation Error',
			description:
				`You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
				'Tracking Plan spec.',
			errors: violations,
		},
		undefined,
		2
	)

	console.warn(msg)
}

let analytics: () => SegmentAnalytics.AnalyticsJS | undefined = () => {
	return window.analytics
}

/** Options to customize the runtime behavior of a Typewriter client. */
export interface TypewriterOptions {
	/**
	 * Underlying analytics instance where analytics calls are forwarded on to.
	 * Defaults to window.analytics.
	 */
	analytics?: SegmentAnalytics.AnalyticsJS
	/**
	 * Handler fired when if an event does not match its spec. This handler
	 * does not fire in production mode, because it requires inlining the full
	 * JSON Schema spec for each event in your Tracking Plan.
	 *
	 * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
	 * if a message does not match the spec. Otherwise, errors will be logged to stderr.
	 */
	onViolation?: ViolationHandler
}

/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options: TypewriterOptions) {
	analytics = options.analytics
		? () => options.analytics || window.analytics
		: analytics
}

/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message: Segment.Options = {}): Segment.Options {
	return {
		...message,
		context: {
			...(message.context || {}),
			typewriter: {
				language: 'typescript',
				version: '7.4.1',
			},
		},
	}
}

/**
 * @typedef AccountCreated
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} [button_or_link_location] - The location of the button or link on the page or screen.
 * @property {string} [button_or_link_text] - The text on the button or link.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef AgreedToTosPrivacy
 * @property {string} [checkbox_location] - The location of the checkbox on the page or screen.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef BackButtonPressed
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef ButtonPressed
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef CaptureStarted
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.

 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef CaptureSubmitted
 * @property {string} [button_location] - The location of the button on the page or screen.

 * @property {string} button_text - The text on the button.

 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.

 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 * @property {boolean} [progressive_upload] - Progressive Uploads was enabled for the capture.
 */
/**
 * @typedef FeatureUpvoted
 * @property {string} feature - The name of the feature the user upvoted.
 * @property {string} page_or_screen_name - The name of the page or screen where the feature was upvoted.
 */
/**
 * @typedef HomeownerIdentified
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef LinkPressed
 * @property {string} [link_location] - The location of the link on the page or screen.
 * @property {string} link_text - The text on the link.
 * @property {string} page_or_screen_name - The name of the page or screen where the link was pressed.
 * @property {boolean} primary_cta - Whether the link is the primary call to action on the page or screen.
 */
/**
 * @typedef LoginSsoStarted
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} [button_or_link_location] - The location of the button or link on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef LoginStarted
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} [button_or_link_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef ProductSelected
 * @property {string} page_or_screen_name - The name of the page or screen where the product was selected.
 * @property {string} parameter - The parameter of the product the user selected. For example, “Roofing Types”, “Style”, etc..
 * @property {string | null} product - The kind of product the user selected. For example, "Walls", "Roof", "Trim", etc..
 * @property {any | null} selection - The option the user selected. For example, “Metal”, “Standing Seam”, etc..
 */
/**
 * @typedef ProfessionalIdentified
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef PropertyPressed
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_text - The text on the button.
 * @property {boolean} [example_job] - Whether the property is an example job.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef SignupStarted
 * @property {string} [button_location] - The location of the button on the page or screen.
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} button_text - The text on the button.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */
/**
 * @typedef SupportContacted
 * @property {string} button_or_link - Whether the element pressed was a button or a link.
 * @property {string} [button_or_link_location] - The location of the button or link on the page or screen.
 * @property {string} button_or_link_text - The text on the button or link.
 * @property {string} page_or_screen_name - The name of the page or screen where the button was pressed.
 * @property {boolean} primary_cta - Whether the button is the primary call to action on the page or screen.
 */

/**
 * The user created an account.
 *
 * @param {AccountCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountCreated(
	props: AccountCreated,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Account Created',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user agreed to the terms of service and privacy policy.
 *
 * @param {AgreedToTosPrivacy} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function agreedToTosPrivacy(
	props: AgreedToTosPrivacy,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Agreed to TOS_Privacy',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed the back button.
 *
 * @param {BackButtonPressed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function backButtonPressed(
	props: BackButtonPressed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Back Button Pressed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed a button. This is the generic event used for all button presses, other than the ones that have their own dedicated event name.
 *
 * @param {ButtonPressed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function buttonPressed(
	props: ButtonPressed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Button Pressed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user started a capture.
 *
 * @param {CaptureStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function captureStarted(
	props: CaptureStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Capture Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user submitted a capture.
 *
 * @param {CaptureSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function captureSubmitted(
	props: CaptureSubmitted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Capture Submitted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user upvoted a potential new feature in Design Studio.
 *
 * @param {FeatureUpvoted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function featureUpvoted(
	props: FeatureUpvoted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Feature Upvoted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user selected the Homeowner option.
 *
 * @param {HomeownerIdentified} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function homeownerIdentified(
	props: HomeownerIdentified,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Homeowner Identified',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed a link. This is the generic event used for all link presses, other than the ones that have their own dedicated event name.
 *
 * @param {LinkPressed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function linkPressed(
	props: LinkPressed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Link Pressed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user started SSO login.
 *
 * @param {LoginSsoStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function loginSsoStarted(
	props: LoginSsoStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Login SSO Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user started login.
 *
 * @param {LoginStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function loginStarted(
	props: LoginStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Login Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user viewed a page. Page calls are automatically converted to this event.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pageViewed(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Page Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user made a product selection in Design Studio.
 *
 * @param {ProductSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productSelected(
	props: ProductSelected,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Product Selected',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user selected the Professional option.
 *
 * @param {ProfessionalIdentified} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function professionalIdentified(
	props: ProfessionalIdentified,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Professional Identified',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user pressed a property on the Property List screen.
 *
 * @param {PropertyPressed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function propertyPressed(
	props: PropertyPressed,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Property Pressed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user viewed a screen. Screen calls are automatically converted to this event.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function screenViewed(
	props?: Record<string, any>,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Screen Viewed',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user started signup.
 *
 * @param {SignupStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signupStarted(
	props: SignupStarted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Signup Started',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}
/**
 * The user contacted Support.
 *
 * @param {SupportContacted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function supportContacted(
	props: SupportContacted,
	options?: Segment.Options,
	callback?: Segment.Callback
): void {
	const a = analytics()
	if (a) {
		a.track(
			'Support Contacted',
			props || {},
			withTypewriterContext(options),
			callback
		)
	}
}

const clientAPI = {
	/**
	 * Updates the run-time configuration of this Typewriter client.
	 *
	 * @param {TypewriterOptions} options - the options to upsert
	 *
	 * @typedef {Object} TypewriterOptions
	 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
	 * 		calls are forwarded on to. Defaults to window.analytics.
	 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
	 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
	 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
	 * 		will be logged to stderr.
	 */
	setTypewriterOptions,
	/**
	 * The user created an account.
	 *
	 * @param {AccountCreated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	accountCreated,
	/**
	 * The user agreed to the terms of service and privacy policy.
	 *
	 * @param {AgreedToTosPrivacy} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	agreedToTosPrivacy,
	/**
	 * The user pressed the back button.
	 *
	 * @param {BackButtonPressed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	backButtonPressed,
	/**
	 * The user pressed a button. This is the generic event used for all button presses, other than the ones that have their own dedicated event name.
	 *
	 * @param {ButtonPressed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	buttonPressed,
	/**
	 * The user started a capture.
	 *
	 * @param {CaptureStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	captureStarted,
	/**
	 * The user submitted a capture.
	 *
	 * @param {CaptureSubmitted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	captureSubmitted,
	/**
	 * The user upvoted a potential new feature in Design Studio.
	 *
	 * @param {FeatureUpvoted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	featureUpvoted,
	/**
	 * The user selected the Homeowner option.
	 *
	 * @param {HomeownerIdentified} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	homeownerIdentified,
	/**
	 * The user pressed a link. This is the generic event used for all link presses, other than the ones that have their own dedicated event name.
	 *
	 * @param {LinkPressed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	linkPressed,
	/**
	 * The user started SSO login.
	 *
	 * @param {LoginSsoStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	loginSsoStarted,
	/**
	 * The user started login.
	 *
	 * @param {LoginStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	loginStarted,
	/**
	 * The user viewed a page. Page calls are automatically converted to this event.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	pageViewed,
	/**
	 * The user made a product selection in Design Studio.
	 *
	 * @param {ProductSelected} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	productSelected,
	/**
	 * The user selected the Professional option.
	 *
	 * @param {ProfessionalIdentified} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	professionalIdentified,
	/**
	 * The user pressed a property on the Property List screen.
	 *
	 * @param {PropertyPressed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	propertyPressed,
	/**
	 * The user viewed a screen. Screen calls are automatically converted to this event.
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	screenViewed,
	/**
	 * The user started signup.
	 *
	 * @param {SignupStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	signupStarted,
	/**
	 * The user contacted Support.
	 *
	 * @param {SupportContacted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */
	supportContacted,
}

export default new Proxy<typeof clientAPI>(clientAPI, {
	get(target, method) {
		if (typeof method === 'string' && target.hasOwnProperty(method)) {
			return target[method as keyof typeof clientAPI]
		}

		return () => {
			console.warn(`⚠️  You made an analytics call (${String(
				method
			)}) that can't be found. Either:
    a) Re-generate your typewriter client: \`npx typewriter\`
    b) Add it to your Tracking Plan: https://app.segment.com/hover3d/protocols/tracking-plans/rs_1kCXzJyCn3GUEonojuBe71ZOlYC`)
			const a = analytics()
			if (a) {
				a.track(
					'Unknown Analytics Call Fired',
					{
						method,
					},
					withTypewriterContext()
				)
			}
		}
	},
})
